
export default {
  name: 'TPShare',
  methods: {
    socialShare(data: any) {
      var w = 760
      var h = 450

      var goal = ''
      if (data.indexOf('vk.com') !== -1) {
        goal = 'VK_SHARE'
        w = 650
        h = 584
      } else if (data.indexOf('facebook.com') !== -1) {
        goal = 'FB_SHARE'
        w = 744
        h = 397
      } else if (data.indexOf('twitter.com') !== -1) {
        goal = 'TW_SHARE'
        w = 687
        h = 253
      } else if (data.indexOf('telegram.me') !== -1) {
        goal = 'TG_SHARE'
        data = data.replace('https://telegram.me/share/url', 'tg://msg_url')
      } else if (data.indexOf('ok.ru') !== -1) {
        goal = 'OK_SHARE'
        w = 600
        h = 435
      } else if (data.indexOf('pinterest.com') !== -1) {
        goal = 'PT_SHARE'
      } else if (data.indexOf('getpocket.com') !== -1) {
        goal = 'PK_SHARE'
        w = 558
        h = 284
      } else if (data.indexOf('mailto:') !== -1) {
        goal = 'EM_SHARE'
      }

      //@ts-ignore
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left

      //@ts-ignore
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top

      var width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width
      var height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height

      var left = width / 2 - w / 2 + dualScreenLeft
      var top = height / 2 - h / 2 + dualScreenTop

      var newWindow = window.open(
        data,
        'fbshare',
        'height=' +
          h +
          ',width=' +
          w +
          ',top=' +
          top +
          ',left=' +
          left +
          ',resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0',
      )

      //@ts-ignore
      if (window.focus) {
        //@ts-ignore
        newWindow.focus()
      }
    },
    getShareText() {
      return `Игра 2048, но вместо чисел надо собирать серверы`
    },
    getShareURL(utm: any) {
      let link = window.location.href.split('?')[0]
      //@ts-ignore
      if (document.querySelector('link[rel=canonical]') && document.querySelector('link[rel=canonical]').href) {
        //@ts-ignore
        link = document.querySelector('link[rel=canonical]').href
      } else if (
        //@ts-ignore
        document.querySelector('meta[itemprop=mainEntityOfPage]') &&
        //@ts-ignore
        document.querySelector('meta[itemprop=mainEntityOfPage]').getAttribute('itemid')
      ) {
        //@ts-ignore
        link = document.querySelector('meta[itemprop=mainEntityOfPage]').getAttribute('itemid')
      }

      return encodeURIComponent(`${link}?utm_source=${utm}`)
    },
    open(type: string) {
      let platform = 'copyLink'
      if (type === 'VK') {
        this.socialShare(
          `https://vk.com/share.php?url=${this.getShareURL('vk')}&title=${encodeURIComponent(
            document.title,
          )}&comment=${this.getShareText()}`,
        )

        platform = 'vk'
      }

      if (type === 'FB') {
        this.socialShare(`https://facebook.com/sharer.php?u=${this.getShareURL('facebook')}`)
        platform = 'fb'
      }

      if (type === 'TW') {
        this.socialShare(
          `https://twitter.com/intent/tweet?url=${this.getShareURL('twitter')}&text=${this.getShareText()}`,
        )

        platform = 'tw'
      }

      if (type === 'TG') {
        window.open(`tg://msg_url?text=${this.getShareText()}&url=${this.getShareURL('telegram')}`, '_self')
        platform = 'tg'
      }

      if (type === 'COPY') {
        let buffer = document.createElement('textarea')
        document.body.appendChild(buffer)
        buffer.value = decodeURIComponent(this.getShareURL('direct'))
        buffer.select()
        document.execCommand('copy')
        document.body.removeChild(buffer)

        //@ts-ignore
        if (window.successNotyf) {
          //@ts-ignore
          window.successNotyf('Ссылка скопирована')
        }

        platform = 'copyLink'
      }

      //@ts-ignore
      if (window.ta) {
        //@ts-ignore
        ta('specials.2048.social.shared', 1, { platform: platform })
      }
    },
  },
}
